module.exports = __webpack_public_path__ + "static/media/ic-recommend-engine.744e7e0c.png";